<div class="organisation-personal">
  <div class="organisation-personal__content content">
    <div class="content__header">
      <button
        *ngIf="!showFullPage && selectedUserId"
        tuiIconButton
        class="content__return-button"
        type="button"
        appearance="icon"
        iconStart="@tui.arrow-left"
        size="s"
        [tuiHint]="'common.buttons.return' | translate"
        (click)="onClickReturnButton()"
      ></button>

      <ng-container *ngIf="showFullPage">
        <h1 class="content__title">{{ title }}</h1>

        <button
          *ngIf="allowEditing$ | async"
          tuiIconButton
          class="button button_add"
          type="button"
          appearance="icon"
          iconStart="@tui.circle-plus"
          size="s"
          [tuiHint]="'common.buttons.add' | translate"
          (click)="onClickAddButton()"
        ></button>
      </ng-container>
    </div>

    <div [hide]="!showFullPage" class="content__list">
      <app-new-list
        [items]="users"
        [itemContentTmp]="userTmp"
        [withCounter]="true"
        [selectedId]="selectedUserId"
        (selectedIdChange)="onChangeSelectedUserId($event)"
      ></app-new-list>
    </div>

    <tui-scrollbar class="content__content" *ngIf="userInfoMode === 'create' || selectedUserId">
      <app-user-info
        [mode]="userInfoMode"
        [userId]="selectedUserId"
        [organisationId]="organisationId"
        [allowExcluding]="allowExcluding"
        (canceled)="onCancelEditingUser()"
        (saved)="onSaveEditingUser()"
        (excluded)="onClickExcludeButton($event)"
      ></app-user-info>
    </tui-scrollbar>
  </div>
</div>

<ng-template #userTmp let-item>
  <new-list-item-user [item]="item"></new-list-item-user>
</ng-template>
